import script from "./BaseAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./BaseAvatar.vue?vue&type=style&index=0&id=676bf714&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676bf714"]])

export default __exports__